module.exports = __webpack_public_path__ + "static/media/clip-board.c1679103.svg";